import { GenericService } from "../GenericService";

class QuestionService extends GenericService {
  constructor() {
    super("/api/admin/question");
  }

  getSingleQuestion = (id) => this.get("/api/question/getSingleFR/" + id);
  getCompanyQuestions = (data) =>
    this.post("/api/admin/question/getCompanyQuestions", data);
  markAsFirst = (data) => this.post("/api/admin/question/markAsFirst", data);
  getFirstQuestion = (data) =>
    this.post("/api/question/getFirstQuestionFR", data);
  getFirstQuestion = (data) =>
    this.post("/api/question/getFirstQuestionFR", data);
}

export default new QuestionService();
